import { GetServerSideProps } from 'next';

/*
    Redirect any old CL reference to new microfrontend
*/

export const getServerSideProps: GetServerSideProps<any, { slug: string[] }> = async ctx => ({
  props: {},
  redirect: {
    destination: `/cl/library/${ctx.params?.slug.join('/')}`,
    basePath: false,
    permanent: true,
  },
});

// this page should never be rendered
export default () => null;
